import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { PageMode } from "utils/constant";
import TableComponent from "./components/Table";
import FormComponent from "./components/Form";

const Mikroskopis = () => {
  const [pageMode, setPageMode] = useState(PageMode.view);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleEditData = (item) => {
    changePageMode(PageMode.edit);
    setSelectedItem(item);
  };
  useEffect(() => {
    document.title = "SISMAL | Mikroskopis - Level Fasyankes";
    window.scrollTo(0, 0);
  }, []);

  const changePageMode = (mode) => {
    setPageMode(mode);
  };

  return (
    <div className="dashboard-wrapper">
      {pageMode === PageMode.view && (
        <TableComponent
          handlePageModeChange={changePageMode}
          pageMode={pageMode}
          handleEditData={handleEditData}
        />
      )}
      {(pageMode === PageMode.add || pageMode === PageMode.edit) && (
        <FormComponent
          selectedItem={selectedItem}
          handlePageModeChange={changePageMode}
          pageMode={pageMode}
        />
      )}
    </div>
  );
};

export default Mikroskopis;
